export function objToFormData(obj) {
  const formData = new FormData();

  for (let i in obj) {
    let value = obj[i] === null ? '' : obj[i];
    formData.append(i, value);
  }

  return formData;
}

/**
 * Convert an image
 * to a base64 url
 * @param  {String}   url
 * @param  {Function} callback
 * @param  {String}   [outputFormat=image/png]
 */
export function convertImgToBase64URL(url) {
  return new Promise(function (resolve) {
    const img       = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload      = function () {
      let canvas = document.createElement('CANVAS');
      const ctx  = canvas.getContext('2d');
      let dataURL;

      canvas.height = img.height;
      canvas.width  = img.width;
      ctx.drawImage(img, 0, 0);
      dataURL = canvas.toDataURL('image/jpeg');
      resolve(dataURL);
      canvas = null;
    };
    img.src         = url;
  });
}

export function isTouch() {
  return !!('ontouchstart' in window);
}

export function isMobile() {
  return !!(navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
  );
}

/**
 * Plural forms for russian words
 * @param  {Integer} count quantity for word
 * @param  {Array} words Array of words. Example: ['депутат', 'депутата', 'депутатов'], ['коментарий', 'коментария', 'комментариев']
 * @return {String}        Count + plural form for word
 */
export function pluralize(count, words) {
  const cases = [2, 0, 1, 1, 1, 2];
  return count + ' ' + words[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[Math.min(count % 10, 5)]];
}
